<script setup>
import Multiselect from "@vueform/multiselect";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: "All trades",
  },
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (val) => {
  emit("update:modelValue", Array.isArray(val) ? val : []);
};
</script>

<template>
  <div class="filter-select">
    <Multiselect
      :modelValue="modelValue"
      :options="options"
      mode="tags"
      :closeOnSelect="true"
      :searchable="true"
      :createOption="false"
      :placeholder="placeholder"
      @update:modelValue="updateValue"
    />
  </div>
</template>

<style scoped>
@import "@vueform/multiselect/themes/default.css";

.filter-select {
  width: 100%;
}

:deep(.multiselect) {
  min-height: 38px;
  font-size: 13px;
}

:deep(.multiselect-tag) {
  background: #00047b;
  color: white;
  font-size: 12px;
}

:deep(.multiselect-dropdown) {
  z-index: 1000;
}
</style>
